import { FileCopyOutlined, QrCode2 } from "@mui/icons-material";
import {
  Avatar,
  Card,
  CardContent,
  CircularProgress,
  Container,
  IconButton,
  Snackbar,
  Stack,
  Typography,
} from "@mui/joy";
import * as React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import HeaderBackButton from "../components/HeaderBackButton";
import styles from "../components/RecieveCard.module.css";
import { db } from "../config/firebase";
import { doc, getDoc } from "firebase/firestore";

export default function Receive() {
  const walletData = useSelector((state) => state.walletsData);

  return (
    <>
      <HeaderBackButton title={"Receive crypto"} />
      <Container maxWidth="md">
        <Stack spacing={2}>
          {walletData.map((coin, index) => (
            <ReceiveCard coin={coin} key={index} />
          ))}
        </Stack>
      </Container>
    </>
  );
}

export const ReceiveCard = ({ coin }) => {
  const navigate = useNavigate();
  const [adminWallet, setadminWallet] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const { coinname, image, code } = coin;
  React.useEffect(() => {
    const docRef = doc(db, "walletaddresses", code);
    getDoc(docRef).then((data) => {
      console.log(data.data());

      if (data.data().address) {
        setadminWallet(data.data().address);
        setLoading(false);
      }
    });
  }, []);

  return (
    <>
      <Card variant="outlined">
        <CardContent>
          <Stack spacing={2} direction={"row"} justifyContent={"space-between"}>
            <Stack direction={"column"} spacing={1}>
              <Typography level="title-md">Your {coinname} address</Typography>
              <div className={styles.mkz6qaujb5nsymzcyzarctrecc2a3h}>
                <Typography level="body-md" noWrap={true}>
                  {adminWallet}
                </Typography>
              </div>
              <Avatar variant="outlined" size="sm" src={image} />
            </Stack>

            <Stack direction={"row"} spacing={1} height={"fit-content"}>
              <IconButton
                size="md"
                variant="outlined"
                sx={{ borderRadius: 50 }}
                onClick={() => navigate("/receive/coin", { state: coin })}
              >
                <QrCode2 />
              </IconButton>
              {loading ? (
                <CircularProgress size="sm" />
              ) : (
                <CopyToClipboard
                  text={adminWallet}
                  onCopy={() => setOpen(true)}
                >
                  <IconButton
                    size="md"
                    variant="outlined"
                    sx={{ borderRadius: 50 }}
                  >
                    <FileCopyOutlined />
                  </IconButton>
                </CopyToClipboard>
              )}
            </Stack>
          </Stack>
        </CardContent>
      </Card>
      <Snackbar
        color="success"
        size="md"
        variant="soft"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={open}
        onClose={handleClose}
      >
        Address copied
      </Snackbar>
    </>
  );
};
